import styled from "styled-components";
import { createGlobalStyle } from "styled-components";

import ASD_FONT_SANS_REGULAR_WEB from "../fonts/ASD_FONT_DISPLAY_APP_REGULAR.ttf";
import ASD_FONT_SANS_BOLD_WEB from "../fonts/ASD_FONT_SANS_BOLD_WEB.woff";
import ASD_FONT_DISPLAY_APP_REGULAR from "../fonts/ASD_FONT_DISPLAY_APP_REGULAR.ttf";

import bgImg from "../img/bg.webp";

export const AsahiFonts = createGlobalStyle`

@font-face {
  font-family: 'ASD Sans-Regular';
  font-style: normal;
  src: url(${ASD_FONT_SANS_REGULAR_WEB}) format('woff');
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
}

@font-face {
  font-family: 'ASD Sans-Bold';
  src: url(${ASD_FONT_SANS_BOLD_WEB}) format('woff');
  font-weight: 700;
}

@font-face {
  font-family: 'ASD Display App-Regular';
  src: url(${ASD_FONT_DISPLAY_APP_REGULAR}) format('truetype');
}
`;

export const theme = {
  colors: {
    backgroundOptions: "#f9f9fa",
    background: "#ffffff",
    divider: "#E0E0E0",
    highEmphasis: "#202020",
    medEmphasis: "#626262",
    surface: "#ffffff",
    primary: "#BA131D"
  }
};

export const fonts = {
  H1: {
    fontFamily: "ASD Display App-Regular",
    fontSize: "32px",
    fontWeight: 400,
    lineHeight: "40px",
    color: theme.colors.highEmphasis
  },
  H2: {
    fontFamily: "ASD Display App-Regular",
    fontSize: "28px",
    fontWeight: 400,
    lineHeight: "36px",
    color: theme.colors.surface
  },

  B1: {
    fontFamily: "ASD Sans-Bold",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 700,
    color: theme.colors.highEmphasis
  },
  B2: {
    fontFamily: "ASD Sans-Regular",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: theme.colors.medEmphasis
  }
};

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: ${theme.colors.background};
`;

export const NavBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.divider};
  padding: 8px 16px;
  .logo {
    height: 40px;
  }
  .balance-container {
    display: flex;
    gap: 8px;
  }
`;

export const Header = styled.header`
  img {
    width: 100%;
    object-fit: cover;
  }
`;

export const H1 = styled.h1`
  ${fonts.H1}
`;

export const H2 = styled.h2`
  ${fonts.H2}
`;

export const B1 = styled.p`
  ${fonts.B1}
`;

export const B2 = styled.p`
  ${fonts.B2}
`;

export const About = styled.section`
  position: relative;
  ::before {
    content: " ";
    display: block;
    position: absolute;
    background-image: url(${bgImg});
    background-size: cover;
    background-position: 50% 50%;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
  }
  margin-top: -5px;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${H1}, ${B2} {
    position: relative;
  }

  ${H1} {
    display: flex;
    flex-direction: column;

    .emph {
      color: ${theme.colors.primary};
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 16px 64px;
  background-color: ${theme.colors.primary};

  ${B1}, ${B2} {
    color: ${theme.colors.surface};
  }

  a {
    text-decoration: underline;
    color: ${theme.colors.surface};
  }
  .powered-by {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    img {
      height: 24px;
    }
  }

  .serial {
    cursor: pointer;
  }
`;
